import { ConsistencerBreakCycles } from './ConsistencerBreakCycles';
import { ConsistencerAdmin } from './ConsistencerAdmin';
export class Consistencer {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    breakCycles = new ConsistencerBreakCycles(this);
    adminConsistency = new ConsistencerAdmin(this);
    get director() {
        return this.parent;
    }
    get app() {
        return this.parent.parent;
    }
}
